import React, {Component} from "react";
import {connect} from "react-redux";
import CarouselItem from "../../../../blocks/CarouselItem";
import {numberWithCommas, removeDecimalsIfNotNeeded, calculateDomain} from "../../../../../helpers/formatters";
import Source from "../../../../items/Source";
import MiniLegend from "../../../../items/MiniLegend";

import {BarChart} from "d3plus-react";

class ProjectedOccupationalChanges extends Component {

  render() {
    const {clustersData, selectedCluster} = this.props;

    const selectedClusterID = selectedCluster.id;
    const clustersIds = [selectedClusterID];

    const filteredData = clustersData.filter(cd => clustersIds.indexOf(cd.cluster_id) > -1);

    const colors = filteredData.map(d => ({color: d.color, label: d.cluster_name}));

    const fields = {
      'net_job_growth_business_legal_professionals_2018_30_in_thousands':'Business/Legal',
      'net_job_growth_stem_professionals_2018_30_in_thousands':'STEAM professionals',
      'net_job_growth_managers_2018_30_in_thousands':'Managers',
      'net_job_growth_creatives_and_arts_management_2018_30_in_thousands':'Creatives & Arts',
      'net_job_growth_educator_and_workforce_training_2018_30_in_thousands':'Educators & Workforce training',
      'net_job_growth_health_aides_technicians_and_wellness_2018_30_in_thousands':'Health aides & technicians',
      'net_job_growth_health_professionals_2018_30_in_thousands':'Health professionals',
      'net_job_growth_property_maintenance_and_agriculture_2018_30_in_thousands':'Property maintence & agriculture',
      'net_job_growth_transportation_services_2018_30_in_thousands':'Transportation services',
      'net_job_growth_customer_service_and_sales_2018_30_in_thousands':'Customer services & sales',
      'net_job_growth_mechanical_installation_repair_2018_30_in_thousands':'Mechanical installation & repair',
      'net_job_growth_builders_2018_30_in_thousands':'Builders',
      'net_job_growth_food_services_2018_30_in_thousands':'Food Services',
      'net_job_growth_production_work_2018_30_in_thousands':'Production work',
      'net_job_growth_community_services_2018_30_in_thousands':'Community services',
      'net_job_growth_office_support_2018_30_in_thousands':'Office Support',
    };

    const finalData = [];
    let xMax = 0;
    let xMin = 0;
    let value;
    Object.keys(fields).forEach(f => {
      filteredData.forEach(fd => {
        value = fd[f];
        finalData.push({cluster_id: fd.cluster_id, cluster_name: fd.cluster_name, property: fields[f], value: value, color: fd.color});
        xMax = xMax < value ? value : xMax;
        xMin = xMin > value ? value : xMin;
      });
    });

    const chartConfig = {
      data: finalData.sort((a,b) => a.value>b.value?1:-1),
      detectVisible: true,
      groupBy: "cluster_name",
      height: 440,
      discrete: "y",
      legend:false,
      y: "property",
      x: "value",
      tooltipConfig: {
        body: d => `<div>${d.property} job growth, thousands: ${removeDecimalsIfNotNeeded(d.value)}</div>`
      },
      yConfig: {
        title: false,
        tickSize: 0
      },
      xConfig: {
        tickFormat: tick => `${numberWithCommas(tick)}`,
        domain: calculateDomain(xMin, xMax)
      },
      shapeConfig: {
        fill: d => d.color,
        duration: 0,
        Bar: {
          label: (d) => (`${removeDecimalsIfNotNeeded(d.value)}`)
        }
      },
      groupPadding: 10,
      barPadding: 5
    };
    return (
      <CarouselItem title="Projected occupational shifts" subtitle={<><b>Net change of jobs,</b> 2018-30, in thousands</>}>
        <div className="fow-col fow-col-1">
          <MiniLegend colors={colors} />
          <BarChart config={chartConfig} />
          <Source text="Source: Eurostat, Oxford Economics; McKinsey Global Institute analysis" />
        </div>
      </CarouselItem>
    );
  }
}

const mapStateToProps = state => {
  return {
    clustersData: state.db.data.dimensions.clusters ? state.db.data.dimensions.clusters : [],
    selectedCluster: state.settings.map["Clusters"]
  };
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ProjectedOccupationalChanges);
